module.exports = __webpack_public_path__ + "static/media/10.ab497f11.jpg";